import React from 'react'
import { Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const StudentOldQuestion2 = ({question, teachername, studentname}) => {

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return (
    <div>
      <div className="timeline-block">
        <span className="timeline-step badge-white bg-gradient-primary">
          <i className="fa fa-question"></i>
        </span>
        <div className="timeline-content">
          <h6 className="text-muted font-weight-bold questionFont">
            <span className='tittleColor questionFont'>Question</span>
          </h6>
          <h6 className="  tittleColor33">
          <span className='tittleColor studenT3'>
            {question.tittle}
          </span>
            </h6>
          <h6 className=" mt-4 mb-0 qAnsw">
          <span className='studenT2'>
            {question.description}
          </span>
            </h6>
          <p className=" text-sm mt-1 mb-0">
          by <span style={{ textTransform: 'capitalize' }}>  {studentname}  </span>
          at {formatDate(question.createdAt)}
          </p>
          <div className="mt-3">
            {question.mediaId != 'none' ? (
            <LinkContainer to={`/studentwatchquestion/${question._id}`} className='btn btn-default'>
              <Button variant="primary offset-xl-2 bg-gradient-primary border border-0 rounded-pill"> Watch Question </Button>
            </LinkContainer>    
            ) : (
              <LinkContainer to={`/studentasktype/${question._id}`} className='btn btn-default'>
              <Button variant="primary offset-xl-2 bg-gradient-primary border border-0 rounded-pill"> Add Video </Button>
            </LinkContainer>  
            )}
          </div>
        </div>                           
      </div>

       <div className="timeline-block">
        <span className="timeline-step badge-white bg-gradient-warning ">
          <i className="ni ni-check-bold"></i>
        </span>
        <div className="timeline-content">
          <h6 className="text-muted font-weight-bold questionFont">                            
            <span className='tittleColor22 questionFont'>Answer</span>
          </h6>
          <h6 className=" mt-3 mb-0"> Waiting for answer ... </h6>
          <div className="mt-3">
          </div>
        </div>   
      </div>         
    </div>
  )
}

export default StudentOldQuestion2
